import { useEffect } from 'react';
import type { SurveyPaginationContext } from '../types';

export function useTrackMaxVisitedPage(context: SurveyPaginationContext): void {
  const { currentPageIndex, paginationRefs } = context;

  useEffect(() => {
    if (paginationRefs.current && currentPageIndex > paginationRefs.current.maxVisitedPageIndex) {
      paginationRefs.current.maxVisitedPageIndex = currentPageIndex;
    }
  }, [currentPageIndex, paginationRefs]);
}
